<template>
  <v-layout row wrap>
    <v-flex xs12 offset-sm2 sm8 offset-md2 md8>
      <remove-order-dialog
        :dialog="showRemoveCombookBindingOrderDialog"
        :remove-order="removeCombookBindingOrder"
        @close="showRemoveCombookBindingOrderDialog = false"
      >
        カートから削除しますか？
      </remove-order-dialog>

      <h1 class="title-page">
        <v-icon class="material-icons">shopping_cart</v-icon>
        <br />カートの中身
      </h1>

      <v-layout mx-3>
        <v-flex xs4 mb-3 py-0 pr-0>
          <square-combook-binding-frame
            :cover-thumbnail-url="combookBindingCover.thumbnailUrl"
          ></square-combook-binding-frame>
        </v-flex>
        <v-flex pl-3 xs7 text-xs-left>
          <div>
            連絡帳製本
            <p class="caption mt-2">
              園・施設名： {{ organization.name }}<br />
              名前： {{ combookBindingCover.kidFullName }} さん<br />
              期間： {{ combookBindingCover.targetPeriodText }}<br />
              表紙デザイン： {{ designTypeLabel }}<br />
              表紙の印字： {{ coverText }}
            </p>
          </div>
        </v-flex>
      </v-layout>
      <div class="text-xs-right mx-3">
        <a
          class="font-weight-bold"
          href="#"
          @click.prevent="showProductDetailFullScreenDialog = true"
          >商品詳細</a
        >
        <v-btn
          dark
          small
          color="negative"
          class="caption pa-0 "
          @click="showRemoveCombookBindingOrderDialog = true"
        >
          <v-icon small class="mr-2">far fa-trash-alt</v-icon>
          削除する
        </v-btn>
      </div>
      <v-divider class="my-3 mx-3"></v-divider>
      <v-layout>
        <v-flex xs12 mx-3>
          <p class="caption">
            ※ 一度のご注文でご購入いただける製本は1種類のみになります。<br />
            複数ご注文される場合は、お手数ですが、1種類ずつお手続きをお願いいたします。
          </p>
        </v-flex>
      </v-layout>
      <v-layout row wrap text-xs-center>
        <v-flex xs12>
          <v-btn
            large
            color="primary"
            class="navigation-button"
            @click="onClickGoStorePageButton"
          >
            注文手続きへ進む
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <section class="text-xs-center pb-4">
            <router-link
              :to="{
                name: 'organizationCombookBinding',
                params: { organizationId }
              }"
            >
              連絡帳製本ページに戻る>>
            </router-link>
          </section>
        </v-flex>
      </v-layout>
    </v-flex>

    <IosSafariTabBarBackgroundBar
      v-show="showProductDetailFullScreenDialog"
    ></IosSafariTabBarBackgroundBar>

    <ProductDetailFullScreenDialog
      :dialog="showProductDetailFullScreenDialog"
      :price-combook-binding="formattedCombookBindingPrice"
      @close-dialog="showProductDetailFullScreenDialog = false"
    />
  </v-layout>
</template>

<script lang="ts">
import { mapGetters } from "vuex";

import { MEDIA_TYPES } from "../../../../../data/constants";
import ApiErrorHandler from "../../../../../mixins/ApiErrorHandler";

import SquareCombookBindingFrame from "../../../../../components/SquareCombookBindingFrame";
import RemoveOrderDialog from "../../components/RemoveOrderDialog";
import IosSafariTabBarBackgroundBar from "packs/site/components/IosSafariTabBarBackgroundBar.vue";
import ProductDetailFullScreenDialog from "../../../../../components/combook_binding/ProductDetailFullScreenDialog";

import Organization from "../../../../../models/Organization";
import SalesManagement from "../../../../../models/SalesManagement";
import CombookBindingCover from "../../../../../models/CombookBindingCover";

const DESIGN_TYPE_LABELS = {
  pastel: "パステル",
  simple: "シンプル"
};

export default {
  components: {
    "square-combook-binding-frame": SquareCombookBindingFrame,
    "remove-order-dialog": RemoveOrderDialog,
    IosSafariTabBarBackgroundBar,
    ProductDetailFullScreenDialog
  },
  mixins: [ApiErrorHandler],
  props: {
    organizationId: {
      type: Number,
      required: true
    },
    organization: {
      type: Organization,
      required: true
    },
    salesManagementId: {
      type: Number,
      required: true
    },
    salesManagement: {
      type: SalesManagement,
      required: true
    },
    combookBindingCover: {
      type: CombookBindingCover,
      required: true
    }
  },
  data() {
    return {
      showRemoveCombookBindingOrderDialog: false,
      showProductDetailFullScreenDialog: false
    };
  },
  computed: {
    ...mapGetters({
      cartCombookBindingMediaType: "cart/combookBindingMediaType",
      cartCombookBindingCoverId: "cart/combookBindingCoverId"
    }),
    designTypeLabel(): string {
      return DESIGN_TYPE_LABELS[this.combookBindingCover.designType];
    },
    coverText(): string {
      return `${this.combookBindingCover.organizationName} / ${this.combookBindingCover.kidName}`;
    },
    formattedCombookBindingPrice(): string {
      const combookBindingPrice = this.salesManagement.prices.find(
        p => p.mediaType.value === MEDIA_TYPES.combook_binding
      );
      return combookBindingPrice
        ? combookBindingPrice.price.toLocaleString()
        : "";
    }
  },
  methods: {
    async removeCombookBindingOrder() {
      try {
        await this.$store.dispatch("cart/deleteCartCombookBinding");
      } catch (errors) {
        this.handleApiErrors(errors, {
          store: this.$store,
          router: this.$router,
          sentry: this.sentry
        });
      }
    },
    onClickGoStorePageButton() {
      this.goStorePage();
    },
    goStorePage() {
      this.$router.push({
        name: "organizationStore",
        params: {
          organizationId: this.organizationId,
          salesManagementId: this.salesManagementId
        }
      });
    }
  }
};
</script>
